
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Vector Smart Object","width":"40","height":"40","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABFklEQVRYhc3XPQrCQBCG4RcFizQexd4DeCaP4F3sBFsRO/EEHsNCLBQigQ2EkJ/9mZ2dhRQhEB6W3ZlvAPbABaiws1bACTjgcLUhZItrTHccygqyj1u3HywgR3EWkLO4kkhvXAlkME4TGY3TQCbjciLFcDmQ4jhJZDacBDI7LgWphotBquNCkMVwPsjiuCmkGdwQ8gqcLeHaVTlc7Z6HFG4hwoMf8O68f4Cv0L+TV/fMNTt3szTjDF0IMzPO1G0tjvQpJcWQIXVOHRlThNWQKR0iO1KifWVDSvZWcWSOxi+GzJlKkpEakSkaqZnngpElwqY3smQSnkVaiOmjSEszxCDS1IDTRy6BjdvFHfAyAGxGhSOwBZ5/UNbGIVUxNdoAAAAASUVORK5CYII="}})])
          )
        }
      }
    